import React from "react";

function Select(props) {
  let {
    label,
    placeholder,
    value,
    type,
    name,
    autoComplete,
    onChange,
    customStyle,
    defaultValue,
    disabled,
    options,
  } = props;
  return (
    <div className="w-full">
      <label
        className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
        htmlFor="grid-last-name"
      >
        {label}
      </label>

      <select
        className={`${customStyle} block w-full border-[#737373] text-gray-700 border  rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500`}
        id={type}
        type={type}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        onChange={onChange}
        name={name}
        defaultValue={defaultValue}
        disabled={disabled}
      >
        <option value="country">Country</option>
        {options.map((option, index) => (
          <option key={index} value={option.code}>
            {option.name}
          </option>
        ))}
      </select>
    </div>
  );
}

export default Select;
